import { monthFormat } from "./month-format";

export function MonthCell({ getValue }) {
    return monthFormat(new Date(getValue()));
}
